import * as Yup from "yup";

export const getQueryFormSchema = (t) => {
  return Yup.object({
    fullName: Yup.string()
      .matches( /^[\u0600-\u06FFA a-zA-Z]*$/, t("special-characters-error"))
      .max(50, t("fullname-character-limit"))
      .required(t("full_name_is_required")),
    email: Yup.string()
      .matches(/^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/, t("invalide-email-address-lebel"))
      .required(t("email_address_is_required")),
    contact: Yup.string()
      .required(t("contact_numbe_is_required"))
      .matches(/^[0-9]*$/, t("mobile-number-minimum-digit-validation")),
    category: Yup.string().required(t("please_select_category")),
    query: Yup.string().required(t("please_select_type_of_query")),
    description: Yup.string()
      .max(500, t("description-character-limit"))
      .required(t("please_enter_query_description")),
  });
};
